<template>
  <div class="main-view">
    <router-view v-slot="{ Component }">
      <keep-alive>
        <component :is="Component" />
      </keep-alive>
    </router-view>
    <van-tabbar route style="height: 50px">
      <van-tabbar-item to="/clockin/onclock" icon="location-o"
        >打卡</van-tabbar-item
      >
      <van-tabbar-item to="/clockin/statistics" icon="chart-trending-o"
        >统计</van-tabbar-item
      >
    </van-tabbar>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped>
.main-view {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 50px;
}
</style>
